import {Component, Input, OnInit} from '@angular/core';
import {PlatformProfile} from "../../../../model/platformprofile";

@Component({
  selector: 'app-portfolio-management',
  templateUrl: './portfolio-management.component.html',
  styleUrls: ['./portfolio-management.component.css']
})
export class PortfolioManagementComponent implements OnInit {

  @Input() platformProfile: PlatformProfile;

  selectedMandateId: string = "init";

  constructor() { }

  ngOnInit(): void {
  }

}
